import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import css from './InviteFriend.module.css';
import { InviteBonusLine, useGrowthStatus } from '../GrowthPromos/GrowthPromos';

// Invite a friend (Sam, Oct 14). Personal link ?ref=<userId>, tracked as signup source.
// Shares from the user's own device only; the site sends nothing.
// Referral reward (Sam, Oct 14): line shown only while the server switch is ON.
export const inviteMessage = link =>
  `I've been having friendly one-on-one chats about things I care about with kind listeners. Thought you'd like it: ${link}`;

const InviteFriend = ({ currentUser, className }) => {
  const me = useSelector(state => state?.user?.currentUser);
  const id = (currentUser || me)?.id?.uuid;
  const [copied, setCopied] = useState(false);
  const [reward, setReward] = useState(null);
  const growth = useGrowthStatus();
  const listenerBonus = !!(growth?.talkerBonus && growth?.listener);
  useEffect(() => {
    if (!id || typeof fetch !== 'function') return;
    let live = true;
    fetch('/api/referral/status', { credentials: 'same-origin' })
      .then(r => (r.ok ? r.json() : null))
      .then(j => live && j && setReward(j))
      .catch(() => {});
    return () => {
      live = false;
    };
  }, [id]);
  if (!id) return null;
  const origin = typeof window !== 'undefined' ? window.location.origin : 'https://sweetlisteners.com';
  const link = `${origin}/?ref=${id}`;
  const msg = inviteMessage(link);
  const canShare = typeof navigator !== 'undefined' && typeof navigator.share === 'function';
  const copy = () => {
    const done = () => {
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2500);
    };
    try {
      navigator.clipboard.writeText(link).then(done, done);
    } catch (e) {
      done();
    }
  };
  const share = () => {
    navigator.share({ title: 'Sweet Skillz', text: msg }).catch(() => {});
  };
  return (
    <section className={[css.root, className].filter(Boolean).join(' ')} data-invite-friend="true">
      <h3 className={css.title}>Invite a friend</h3>
      <p className={css.body}>Know someone who’d enjoy a good conversation? Share your personal link.</p>
      <InviteBonusLine />
      {reward?.enabled && !listenerBonus ? (
        <p className={css.body} data-invite-reward="true">
          Give a Sweet Treat, get a Sweet Treat. Your friend gets $10 off their first chat when they sign up (a free 15-minute text chat). When they finish their first conversation, you get one too.
          {reward.credits > 0 ? ` You have ${reward.credits} free text chat${reward.credits === 1 ? '' : 's'} to use.` : ''}
        </p>
      ) : null}
      <div className={css.linkRow}>
        <input className={css.link} readOnly value={link} aria-label="Your invite link" onFocus={e => e.target.select()} />
      </div>
      <div className={css.actions}>
        {canShare ? (
          <button type="button" className={css.primary} onClick={share} data-invite-share="true">Share</button>
        ) : null}
        <button type="button" className={css.btn} onClick={copy} data-invite-copy="true">{copied ? 'Copied!' : 'Copy link'}</button>
        <a className={css.btn} href={`sms:?&body=${encodeURIComponent(msg)}`} data-invite-sms="true">Text</a>
        <a className={css.btn} href={`mailto:?subject=${encodeURIComponent('Thought you’d like this')}&body=${encodeURIComponent(msg)}`} data-invite-email="true">Email</a>
      </div>
    </section>
  );
};

export default InviteFriend;
